// 本地环境配置
module.exports = {
  title: '共创家—社区后台管理',
  baseUrl: 'http://visitor.cbo1.jifenxitong.com/', // 项目地址
  baseApi: '/cbo', // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  APPID: 'wx489c93ebee8842f2',
  APPSECRET: '',
  $cdn: 'https://hyjy-oss.oss-cn-chengdu.aliyuncs.com/mp/assets/'
}
